module.exports = __webpack_public_path__ + "static/media/6.eb6dfa58.jpg";